"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
function Microphone({ className, ...rest }) {
    return (react_1.default.createElement("svg", { "aria-hidden": "true", "data-icon": "microphone-on", focusable: "false", role: "img", xmlns: "http://www.w3.org/2000/svg", className: `${className != null && className}`, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, ...rest },
        react_1.default.createElement("title", null, rest.title),
        react_1.default.createElement("path", { d: "M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" }),
        react_1.default.createElement("path", { d: "M19 10v2a7 7 0 0 1-14 0v-2" }),
        react_1.default.createElement("line", { x1: "12", x2: "12", y1: "19", y2: "22" })));
}
exports.default = Microphone;
//# sourceMappingURL=Microphone.js.map